import { z } from 'zod';
/**
 * YARA rule metadata schema
 */
export const yaraRuleMetadataSchema = z.object({
    id: z.string(),
    severity: z.string(),
    description: z.string().optional(),
});
/**
 * YARA rules metadata response schema
 */
export const yaraRulesMetadataSchema = z.object({
    totalRules: z.number(),
    compressionRatio: z.number(),
    lastUpdated: z.number(), // Timestamp in milliseconds
});
/**
 * YARA rules response schema
 */
export const yaraRulesResponseSchema = z.object({
    rules: z.array(yaraRuleMetadataSchema),
    compressedRules: z.string(), // Base64 encoded compressed YARA rules
    metadata: yaraRulesMetadataSchema,
});
/**
 * YARA rules version check response schema
 */
export const yaraRulesVersionResponseSchema = z.object({
    hasChanges: z.boolean(),
    lastUpdated: z.number(), // Timestamp in milliseconds
    ruleCount: z.number(),
});
/**
 * YARA rules version query schema
 */
export const yaraRulesVersionQuerySchema = z.object({
    lastUpdated: z.coerce.number().int().optional(),
});
//# sourceMappingURL=yara-rules.js.map